<template>
<div class="container page">
    <div class="row">
        <div class="col-md-3 mb-5">
            <h1>Profiel</h1>
            <ul class="nav flex-column nav-pills visible-md invisible-sm">
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfileOverview' }" :class="['nav-link', this.$route.name == 'ProfessionalProfileOverview' ? 'active' : '']" >Overzicht</router-link>
                </li>
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfileRates' }" :class="['nav-link', this.$route.name == 'ProfessionalProfileRates' ? 'active' : '']" >Tarieven</router-link>
                </li>
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfileEducations' }" :class="['nav-link', this.$route.name == 'ProfessionalProfileEducations' ? 'active' : '']" >Opleidingen</router-link>
                </li>
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfileWorkArea' }" :class="['nav-link', this.$route.name == 'ProfessionalProfileWorkArea' ? 'active' : '']" >Vak- & Werkgebied</router-link>
                </li>
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfilePassManager' }" :class="['nav-link', this.$route.name == 'ProfessionalProfilePassManager' ? 'active' : '']" >Pasmanager</router-link>
                </li>
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfilePayment' }" :class="['nav-link', this.$route.name == 'ProfessionalProfilePayment' ? 'active' : '']" >Betalingsgegevens</router-link>
                </li>
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfileCredits' }" :class="['nav-link', this.$route.name == 'ProfessionalProfileCredits' ? 'active' : '']" >Credits</router-link>
                </li>
                <li class="nav-item">
                    <router-link tag="a" :to="{ name: 'ProfessionalProfileReferral' }" :class="['nav-link', this.$route.name == 'ProfessionalProfileReferral' ? 'active' : '']" >Referral Programma</router-link>
                </li>
            </ul>
            <select class="form-control visible-sm invisible-md" @change="onRoute">
                <option value="ProfessionalProfileOverview" :selected="$route.name == 'ProfessionalProfileOverview'">Overzicht</option>
                <option value="ProfessionalProfileRates" :selected="$route.name == 'ProfessionalProfileRates'">Tarieven</option>
                <option value="ProfessionalProfileEducations" :selected="$route.name == 'ProfessionalProfileEducations'">Opleidingen</option>
                <option value="ProfessionalProfileWorkArea" :selected="$route.name == 'ProfessionalProfileWorkArea'">Vak- & Werkgebied</option>
                <option value="ProfessionalProfilePassManager" :selected="$route.name == 'ProfessionalProfilePassManager'">Pasmanager</option>
                <option value="ProfessionalProfilePayment" :selected="$route.name == 'ProfessionalProfilePayment'">Betalingsgegevens</option>
                <option value="ProfessionalProfileCredits" :selected="$route.name == 'ProfessionalProfileCredits'">Credits</option>
                <option value="ProfessionalProfileReferral" :selected="$route.name == 'ProfessionalProfileReferral'">Referral Programma</option>
            </select>
        </div>
        <div class="col-md-9">
            <div class="alert alert-success" role="alert" v-if="status == 2">
                <strong>Goedgekeurd!</strong> Uw profiel is goedgekeurd.
            </div>
            <div class="alert alert-warning" role="alert" v-else-if="status == 1">
                <strong>In afwachting van goedkeuring!</strong> Uw profiel wordt momenteel beoordeeld door iemand bij Azurity. Dit proces duur maximaal 10 werkdagen. Mochten er vragen zijn, nemen wij zo spoedig mogelijk contact op.
            </div>
            <div class="alert alert-danger" role="alert" v-else-if="status == 3">
                <strong>Afgekeurd!</strong> Neem contact op met Azurity: <a href="mailto:info@azurity.nl">info@azurity.nl</a>.
            </div>
            <div class="text-center" v-show="isLoading" >
                <loader width="5rem"></loader>
            </div>
            <router-view :user="user" @loading="loading" v-show="!isLoading"></router-view>
            <div class="alert alert-secondary mt-5" role="alert">
                <strong>Wijziging!</strong> Om een wijziging door te geven, neem contact op met <a href="mailto:info@azurity.nl">info@azurity.nl</a>.
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Loader from '@/components/Loader'
export default {
    components: {
        'loader': Loader
    },
    data() {
        return {
            isLoading: true,
            isValid: true,
            isWaiting: true,
            user: null
        }
    },
    mounted() {
        this.$http.get('api/User/Professional').then((res) => {
            this.user = res.data;
            this.isLoading = false;
        })
    },
    methods:{
        loading(val)
        {
            this.isLoading = val;
        },
        onRoute(el)
        {
            return this.$router.push({ name: el.currentTarget.value });
        }
    }, 
    computed: {
        profile() {
            if(this.user)
                return this.user.professionalProfile;
            return {};
        },
        status() {
            return this.profile.profileStatusId;
        }
    }
}
</script>